import { render, staticRenderFns } from "./GenericTeaserCard.vue?vue&type=template&id=3885ab12&"
import script from "./GenericTeaserCard.vue?vue&type=script&lang=js&"
export * from "./GenericTeaserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports